import { useRef, useEffect } from 'react'
import { createPortal } from 'react-dom'
import Head from './Head.jsx';
import Body from './Body.jsx';
import Foot from './Foot.jsx';
import Button from '../Button.jsx';

const Modal = function({rootElementId, title, footButtons, children, open, closeTopButton}) {
  const dialog = useRef()

  useEffect(() => {
    if (open) {
      dialog.current.showModal()
    } else {
      dialog.current.close()
    }
  }, [open])

  const resolveCloseHandler = function() {
    if (typeof closeTopButton === "function") return closeTopButton
    const footClose = footButtons.find((button) => button.type.toUpperCase() === "CLOSE")
    if (footClose) return footClose.onClick
    return () => dialog.current.close()
  }

  const findCloseButton = function() {
    if (closeTopButton) {
      return {type: 'close', styleName: 'alternative', onClick: resolveCloseHandler(), buttonCaption: 'X'}
    }
    return footButtons.find((button) => button.type.toUpperCase() === "CLOSE")
  }

  const handleBackdropClick = function(event) {
    if (event.target === dialog.current) {
      resolveCloseHandler()()
    }
  }

  return createPortal(
    <dialog ref={dialog} tabIndex="-1" aria-hidden="true" onClick={handleBackdropClick} className="backdrop:bg-stone-900/90 rounded-md shadow-md relative w-full max-w-2xl max-h-full">
      <Head title={title} closeButton={findCloseButton()}/>
      <Body>{children}</Body>
      { footButtons.length > 0 &&
        <Foot>
          {
            footButtons.map((button) => {
                return <Button key={button.type} styleName={button.styleName} onClick={button.onClick}>{button.buttonCaption}</Button>
              }
            )
          }
        </Foot>
      }
    </dialog>,
    document.getElementById(`${rootElementId}`)
  )
}

export default Modal
